import * as ROUTES from './routes'

export const navMenu = [
  {
    children: [
      {
        children: [
          {
            key: ROUTES.PLAYERS_EPPP,
            label: 'Players - EPPP'
          },
          {
            key: ROUTES.COACHES_ECP,
            label: 'Coaches - ECP'
          },
          {
            key: ROUTES.MATCH_OFFICIALS_ERDP,
            label: 'Match Officials - ERDP'
          }
        ],
        label: 'STRATEGIC',
        type: 'group'
      },
      {
        children: [
          {
            key: ROUTES.HIGH_POTENTIAL,
            label: 'High Potential'
          },
          {
            key: ROUTES.PERFORMANCE_PATHWAY,
            label: 'Performance Pathway'
          },
          {
            key: ROUTES.DUTY_OF_CARE,
            label: 'Duty of Care'
          },
          {
            key: ROUTES.GOVERNANCE_AND_QA,
            label: 'Governance & QA'
          },
          {
            disabled: true,
            key: ROUTES.INNOVATION_AND_INSIGHTS,
            label: 'Innovation and Insights'
          },
          {
            disabled: true,
            key: ROUTES.EQUALITY_DIVERSITY_INCLUSION,
            label: 'Equality, Diversity & Inclusion'
          }
        ],
        label: 'OPERATIONAL',
        type: 'group'
      }
    ],
    id: 'football-development',
    key: ROUTES.FOOTBALL_DEVELOPMENT,
    title: 'Football Development'
  },
  {
    children: [
      {
        key: ROUTES.KPIS,
        label: 'KPIs'
      },
      {
        key: ROUTES.PLAYING_TIME,
        label: 'Playing Time'
      },
      {
        key: ROUTES.ATTENDANCE,
        label: 'Attendance'
      },
      {
        key: ROUTES.OFFICIATING,
        label: 'Officiating'
      },
      {
        disabled: true,
        key: ROUTES.SUBSTITUTIONS,
        label: 'Substitutions'
      }
    ],
    id: 'football-operations',
    key: ROUTES.FOOTBALL_OPERATIONS,
    title: 'Football Operations'
  },
  {
    children: [
      {
        key: ROUTES.TRANSFERS,
        label: 'Transfers'
      },
      {
        key: ROUTES.PLAYER_REGISTRATIONS,
        label: 'Player Registrations'
      },
      {
        disabled: true,
        key: ROUTES.STAFF_REGISTRATIONS,
        label: 'Staff Registrations'
      }
    ],
    id: 'football-administration',
    key: ROUTES.FOOTBALL_ADMINISTRATION,
    title: 'Football Administration'
  }
]
